<div class="flex flex-col h-screen w-full bg-mainGrey relative overflow-hidden">
  <!-- Background image with overlay -->
  <div
    class="absolute inset-0 bg-cover bg-center"
    style="background-image: url('https://easy-fitpass.com/wp-content/uploads/2025/01/Pfad-10005.jpg'); filter: brightness(0.4)"
  ></div>

  <!-- Main content -->
  <div class="relative z-10 flex flex-col h-full">
    <!-- Header with logo and FAQ button -->
    <header class="p-4 flex justify-between items-center">
      <div class="flex items-center">
        <img src="/assets/logo/logo-horizontal.svg" alt="Easy Fitpass" class="h-12" data-cy="logo" />
      </div>
      <a
        href="https://easy-fitpass.com/#faq"
        target="_blank"
        class="bg-mainBlue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md transition duration-200 text-lg cursor-pointer"
        data-cy="faq-link"
      >
        FAQ
      </a>
    </header>

    <!-- Login form container -->
    <div class="flex-grow flex items-center justify-center">
      <div class="w-full max-w-md p-8 rounded-lg bg-greyBackground backdrop-blur-sm">
        <h2 class="text-white text-xl font-semibold mb-6 text-center">In Ihrem Account einloggen</h2>

        <div class="space-y-6">
          <button
            (click)="login()"
            data-cy="login-submit"
            class="w-full py-2 px-4 bg-mainBlue hover:bg-blue-700 text-white font-medium rounded-md transition duration-200 flex items-center justify-center gap-2 cursor-pointer"
          >
            Anmelden
          </button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer class="p-6 bg-footerBackground relative z-10">
      <div class="container mx-auto">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <!-- Logo -->
          <div class="mb-4 md:mb-0">
            <img src="/assets/logo/logo-horizontal.svg" alt="Easy Fitpass" class="h-8" />
          </div>

          <!-- Links -->
          <div class="flex space-x-6 text-white text-sm">
            <a target="_blank" href="https://easy-fitpass.com/impressum" class="hover:text-mainBlue">Impressum</a>
            <a target="_blank" href="https://easy-fitpass.com/datenschutz-app" class="hover:text-mainBlue">Datenschutz</a>
          </div>

          <!-- Social media icons -->
          <div class="flex space-x-4 mt-4 md:mt-0">
            <a href="#" class="text-white hover:text-mainBlue">
              <img src="/assets/icons/whatsapp.svg" alt="Whatsapp" class="h-6 w-6" />
            </a>
            <a href="#" class="text-white hover:text-mainBlue">
              <img src="/assets/icons/instagram.svg" alt="Instagram" class="h-6 w-6" />
            </a>
            <a href="#" class="text-white hover:text-mainBlue">
              <img src="/assets/icons/youtube.svg" alt="YouTube" class="h-6 w-6" />
            </a>
            <a href="#" class="text-white hover:text-mainBlue">
              <img src="/assets/icons/facebook.svg" alt="Facebook" class="h-6 w-6" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</div>
